import { getMainDomain } from "./DomainUtils.js";
import { useRequestURL } from "#imports";
export function logout(callbackUrl) {
  if (!process.client) return;
  callbackUrl = callbackUrl || window.location.href;
  const mainDomain = getMainDomain(window.location.host);
  const logoutUrl = `https://account.${mainDomain}/logout?callback_url=${encodeURIComponent(callbackUrl)}`;
  if (window.ssoLogout) {
    window.ssoLogout.logout({
      logoutUrl,
      logoUrl: ""
    });
  } else {
    window.location.href = logoutUrl;
  }
}
export function getLogoutUrl(callbackUrl) {
  const host = useRequestURL().host;
  const mainDomain = getMainDomain(host);
  return `https://account.${mainDomain}/logout?callback_url=${encodeURIComponent(callbackUrl)}`;
}
